import { render, staticRenderFns } from "./SalaryView.vue?vue&type=template&id=cb08cd60&"
import script from "./SalaryView.vue?vue&type=script&lang=js&"
export * from "./SalaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports